import request from '@/util/request';
import qs from 'qs';

// 分页
export const getPageListApi = (params, options) =>
  request.get(
    '/api/v4ward/callcenter/repository/material/file/page',
    Object.assign({}, options, { params })
  );

// 新增
export const addApi = (params, options) =>
  request.post('/api/v4ward/callcenter/repository/material/file/save', params, options, {
    ContentType: 'application/json',
  });

// 修改
export const updateApi = (params, options) =>
  request.post('/api/v4ward/callcenter/repository/material/file/update', params, options, {
    ContentType: 'application/json',
  });

// 删除
export const delApi = (params, options) =>
  request.post(
    '/api/v4ward/callcenter/repository/material/file/remove',
    qs.stringify(params),
    options
  );

// 详情
export const detailApi = (params, options) =>
  request.get(
    '/api/v4ward/callcenter/repository/material/file/detail',
    Object.assign({}, options, { params })
  );

// 树-列表
export const treeListApi = (params, options) =>
  request.get(
    '/api/v4ward/callcenter/repository/material/menu/lazyTree',
    Object.assign({}, options, { params })
  );

// 树-新增
export const treeAddApi = (params, options) =>
  request.post('/api/v4ward/callcenter/repository/material/menu/save', params, options, {
    ContentType: 'application/json',
  });

// 树-修改
export const treeUpdateApi = (params, options) =>
  request.post('/api/v4ward/callcenter/repository/material/menu/update', params, options);

// 树-删除
export const treeDelApi = (params, options) =>
  request.post(
    '/api/v4ward/callcenter/repository/material/menu/remove',
    qs.stringify(params),
    options
  );
